// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.slide-it[data-v-f03212ae]  .slick-slide{\n  padding:10px\n}\n.slide-it[data-v-f03212ae]  .slick-list{\n  margin:-10px\n}\n@media only screen and (max-width:768px){\n.slide-it[data-v-f03212ae]  .slick-list{\n    overflow:initial\n}\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
